module.exports = __webpack_public_path__ + "static/media/close.eee8b1e9.svg";